import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const containerPackageApi = createApi({
  reducerPath: "containerPackageApi",
  baseQuery,
  tagTypes: ["ContainerPackage"],
  endpoints: (builder) => ({
    // GET by exporterMasterId
    getPackageDetailsByMasterId: builder.query({
      query: (exporterMasterId) => `container/packingDetails/${exporterMasterId}`,
      transformResponse: (response) => response?.data ?? [],
      providesTags: ["ContainerPackage"],
    }),

    // GET by exporterMasterId + packingDetailsId
    getPackageDetailsById: builder.query({
      query: ({ exporterMasterId, packingDetailsId }) =>
        `container/packingDetails/${exporterMasterId}/${packingDetailsId}`,
      transformResponse: (response) => response?.data ?? {},
      providesTags: ["ContainerPackage"],
    }),

    // CREATE
    createPackageDetails: builder.mutation({
      query: ({ exporterMasterId, packingDetails }) => ({
        url: `container/packingDetails/${exporterMasterId}`,
        method: "POST",
        body: { packingDetails },
      }),
      invalidatesTags: ["ContainerPackage"],
    }),

    // UPDATE
    updatePackageDetails: builder.mutation({
      query: ({ exporterMasterId, packingDetailsId, packingDetails }) => ({
        url: `container/packingDetails/${exporterMasterId}/${packingDetailsId}`,
        method: "PUT",
        body: { packingDetails },
      }),
      invalidatesTags: ["ContainerPackage"],
    }),

    // DELETE
    deletePackageDetails: builder.mutation({
      query: ({ packingDetailsId }) => ({
        url: `container/packingDetails/${packingDetailsId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ContainerPackage"],
    }),
  }),
});

export const {
  useGetPackageDetailsByMasterIdQuery,
  useyGetPackageDetailsByIdQuery,
  useCreatePackageDetailsMutation,
  useUpdatePackageDetailsMutation,
  useDeletePackageDetailsMutation,
} = containerPackageApi;
